import { useEffect } from 'react';

type OnCloseType = (() => void) | undefined;

export const useEscModalClose = (onClose: OnCloseType): void => {
  useEffect(() => {
    if (!onClose) return;

    const handleEsc = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEsc);

    return (): void => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);
};